import React from "react";
import BlogPostInAPage from "../blogPages/BlogPagePosts/blogPostInAPage";

function Learn() {
  return (
    <div className="learnParent">
      <BlogPostInAPage />
    </div>
  );
}

export default Learn;
